<template>
	<div>
		<BubbleMenu
			v-if="editor"
			:editor="editor"
			class="template-bubble-menu flex-column pa-3"
			:tippy-options="{ duration: 100, arrow: true, flipBehavior: ['top', 'bottom'], onHide: clearTagText }"
		>
			<div class="title-text">Tag this selection</div>
			<EditableTextField class="mt-5" dontSaveOnBlur ref="tag" isEditing :text="tag" @onSave="onSave" placeholder="Tag name" />
			<AnemicButton class="save-button mt-3" @click="onClickSave">Save</AnemicButton>
		</BubbleMenu>
	</div>
</template>

<script>
import { BubbleMenu } from '@tiptap/vue-2';
import EditableTextField from '@/components/common/EditableTextField';
export default {
	name: 'TemplateBubbleMenu',
	components: {
		BubbleMenu,
		EditableTextField,
	},
	props: {
		editor: { type: Object },
	},
	watch: {
		'editor.view.state.selection'(newV, oldV) {
			if (newV && newV !== oldV) {
				this.selectionObj = newV;
				this.tag = '';
			}
		},
	},
	mounted() {
		this.tag = '';
	},
	methods: {
		onSave(newV) {
			this.tag = newV;
			newV?.length > 0 && this.saveTag();
		},
		onClickSave() {
			this.$refs.tag.saveName();
		},
		clearTagText() {
			this.tag = '';
			this.$refs.tag.onDelete();
		},
		saveTag() {
			const state = this.editor.state;
			this.editor
				.chain()
				.command(({ tr }) => {
					const newNode = state.schema.text('[[' + this.tag + ']]');
					this.tag = '';
					tr.replaceSelectionWith(newNode);
					return true;
				})
				.run();
		},
		cancel() {
			this.editor.chain().run();
		},
	},
	data() {
		return {
			selectionObj: null,
			tag: '',
		};
	},
};
</script>
<style lang="scss">
.template-bubble-menu {
	background-color: var(--bg-color);
	padding: 6px 4px;
	border-radius: 6px;
	color: black;
}
.title-text {
	font-size: 16px;
	font-weight: 600;
	text-align: center;
	color: var(--primary-font-color);
}
.tippy-box {
	background-color: transparent;
	box-shadow: var(--secondary-box-shadow);
	.tippy-content {
		padding: 0;
		border: none;
	}
}
.save-button {
	width: 170px;
	padding: 0px !important;
	height: 35px !important;
	font-size: 13px !important;
	font-weight: 600 !important;
	border-radius: 8px !important;
	letter-spacing: 0px !important;
	text-transform: none !important;
	background: var(--bg-color) !important;
	color: var(--primary-color) !important;
	border: 1px solid var(--primary-color) !important;
}
</style>
